import React from 'react';

import moment from 'moment';

import { DataComparisonRow } from './data-comparison-row';

type InputProps = {
  label: string;
  field: keyof EmployeeMergeResolutionType;
  existingDataValue: string | null;
  comparisonDataValue?: string | null;
  selectedValue?: string | null;
  updateField: (
    field: keyof EmployeeMergeResolutionType,
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  addDiscrepancy: (field: keyof EmployeeMergeResolutionType) => void;
};

export const DataComparisonDateRow = ({
  label,
  field,
  existingDataValue,
  comparisonDataValue,
  selectedValue,
  updateField,
  addDiscrepancy,
}: InputProps) => {
  const existingDateString = existingDataValue
    ? moment.utc(existingDataValue).format('MM-DD-YYYY')
    : null;
  const comparisonDateString = comparisonDataValue
    ? moment.utc(comparisonDataValue).format('MM-DD-YYYY')
    : null;

  return (
    <DataComparisonRow
      label={label}
      field={field}
      existingDataValue={existingDateString}
      comparisonDataValue={comparisonDateString}
      selectedValue={selectedValue}
      updateField={updateField}
      addDiscrepancy={addDiscrepancy}
    />
  );
};
